// Render all letter bodies by drawing their glyph at the body's position & angle.

import Matter from 'matter-js';
import type { Surface } from '../render/canvas.js';
import { getLetterPlugin } from '../physics/letterBody.js';
import { DROP_FONT } from './dropString.js';

export function drawLetters(surface: Surface, engine: Matter.Engine): void {
  const { ctx } = surface;
  ctx.save();
  ctx.font = DROP_FONT;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillStyle = 'rgba(0, 0, 0, 0.88)';

  const bodies = Matter.Composite.allBodies(engine.world);
  for (const body of bodies) {
    const plugin = getLetterPlugin(body);
    if (!plugin) continue;

    ctx.save();
    ctx.translate(body.position.x, body.position.y);
    ctx.rotate(body.angle);
    ctx.fillText(plugin.char, 0, 0);
    ctx.restore();
  }

  ctx.restore();
}
